module.exports = __webpack_public_path__ + "fromGroomToFather-jp-b.38e3693a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-jp-b.jpg
// module id = LhdY
// module chunks = 0